
<template>
<div class="flex flex-col w-screen">
<div class="content">
  <div style="position: absolute;top: -3%;left:10px;color: #fffffd;cursor:pointer;">
    <span @click="$router.push({ path: '/' })">首页</span> /
    <span>{{ firstMenuName }}</span> /
    <span v-if="menuName">{{ menuName }}</span>
  </div>
  <div class="dropdown">
    <div class="dropdown-header" >
      <p> {{firstMenuName}}</p>
      <p class="el-icon-plus" @click="toggleDropdown()" v-if="!isShowSelect"></p>
      <p class="el-icon-minus" @click="toggleDropdown()" v-else></p>
    </div>
    <div class="dropdown-content" id="dropdownContent">
      <mobile-menu-item
        v-for="(item, i) in sidebarTree"
        :key="i"
        :item="item"
        :level="0"
        :active-id="menuId"
        @select="handleDropdownSelect"
      />
    </div>
  </div>
  <div class="content-list">
    <el-card v-for="(c,i) in contentList" :key="i" :class="i==activeIndex?'active_card':'card_data'" @click.native="toDetail(c,i)">
      <div class="card_flex">
        <div class="left_box">
          <p style="height: 50px" class="title">{{c.title}}</p>
          <p class="titleTime">{{c.addDate.substr(0,11)}}</p>
        </div >
        <div class="right_box">
          <img @error="handleImageError" :src="c.picUrl?'/mainsys/UserFiles/menupic/'+c.picUrl:defaultImg" alt="">
        </div>
      </div>
    </el-card>
    <div>
      <el-pagination
        style="text-align: center;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 40, 50, 60]"
        :page-size="length"
        layout="total, sizes, jumper, prev, next"
        :total="total"
        v-if="total>0"
      >
      </el-pagination>
    </div>
  </div>
</div>
</div>
</template>


<script>
import defaultImg from "@/assets/2.png"
import {mapGetters} from "vuex";
import MobileMenuItem from "@/components/MobileMenuItem.vue";
export default {
  components: { MobileMenuItem },
  name: "list",
  data() {
    return {
      fullscreenLoading: false,
      menuId: this.$route.params.menuId,
      firstMenuName: "",
      firstMenuId: "",
      menuList: [],
      contentList: [],
      total: 0, //总页数
      page: 1, //页码
      length: 10, //长度
      linkAddress: "", //链接地址
      activeIndex:0,//默认选中样式
      defaultImg:defaultImg,
      isShowSelect:false,//菜单下拉是否展开
      menuName:0,
    };
  },
  computed: {
    ...mapGetters(["isMobile"]),
    sidebarTree() {
      return this.buildSidebarFromNavList(this.$store.state.navList, this.menuId)
    }
  },
  methods: {
    findInTree(items, menuId) {
      for (const item of items) {
        if (String(item.id) === String(menuId)) return true
        if (item.children && item.children.length > 0) {
          if (this.findInTree(item.children, menuId)) return true
        }
      }
      return false
    },
    normalizeTree(items) {
      return (items || []).map(item => ({
        ...item,
        label: item.label || item.text,
        children: item.children && item.children.length > 0 ? this.normalizeTree(item.children) : undefined
      }))
    },
    buildSidebarFromNavList(navList, menuId) {
      if (!navList || !navList.length) return this.menuList || []
      for (const topItem of navList) {
        if (String(topItem.id) === String(menuId)) {
          return this.normalizeTree(topItem.children)
        }
        if (topItem.children && topItem.children.length > 0) {
          const found = this.findInTree(topItem.children, menuId)
          if (found) {
            return this.normalizeTree(topItem.children)
          }
        }
      }
      return this.menuList || []
    },
    handleImageError(e){
      e.target.src = require('../../assets/2.png')
    },
    toggleDropdown(){
      this.isShowSelect = !this.isShowSelect;
      const dropdown = document.querySelector('.dropdown');
      dropdown.classList.toggle('open');
    },
    handleDropdownSelect(item) {
      this.page=1
      this.$router.push({
        path: "List:menuId",
        name: "List",
        params: { menuId: item.id, label: item.label || item.text }
      });
      this.toggleDropdown()
    },
    // 每页条数变化
    handleSizeChange(val) {
      this.length = val;
      this.page = 1;
      this.getSecondList();
    },
    // 页码变化
    handleCurrentChange(val) {
      this.page = val;
      this.getSecondList();
    },
    getSecondList() {
      this.fullscreenLoading = true;
      let fd = new FormData();
      fd.append("page", this.page);
      fd.append("num", this.length);
      var choosedItem = {};
      // console.log("this.firstMenuName", this.firstMenuName);
      axios
        .post("/cmsapi/menus/" + this.$route.params.menuId, fd, {
          //顶部友情链接
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        })
        .then(response => {
          var recData = response.data;
          if (recData.secondMenu.length > 0) {
            recData.secondMenu.forEach((item, index) => {
              if (item.id == this.menuId) {
                choosedItem = item;
                this.linkAddress = item.href ? item.href : "";
              }
            });
          }

          this.total = recData.total;
          //在result里面还有个菜单路径，用的话在这里处理
          //self.menuList = result;
          this.firstMenuName = recData.firstMenuName;
          console.log("recData", recData)
          this.menuName = recData.menuName;
          console.log("this.firstMenuName", this.firstMenuName);
          this.firstMenuId = recData.menuId;
          this.contentList = recData.dataList;
          //如果没有文章，跳转到第一个二级菜单
          /*if(this.total == 0) {
      }*/
          //如果只有一条就跳转,直接显示文章

          // if(this.total == 1) {
          //   this.$router.push({
          //     path:'detail:contentId',
          //     name:'Detail',
          //     params:{contentId:this.contentList[0].id,label:this.contentList[0].title}
          //   });
          //
          //   // window.location.href = "detail.html?contentId="+this.contentList[0].id;
          // }

          if (
            recData.menuName == "仪器预约记录" ||
            recData.menuName == "实验室预约记录" ||
            choosedItem.label == "使用记录" ||
            recData.menuName == "考勤记录" ||
            recData.menuName == "实验室信息" ||
            recData.menuName == "成绩查询" ||
            recData.menuName == "违规扣分处罚信息"
          ) {
            this.$router.push({
              path: "detail:contentId",
              name: "Detail",
              params: {
                contentId: this.contentList[0].id,
                label: recData.menuName
              }
            });
          } else if (this.total == 1) {
            this.$router.push({
              path: "detail:contentId",
              name: "Detail",
              params: {
                contentId: this.contentList[0].id,
                label: this.contentList[0].title
              }
            });
          }

          //如果只有一级菜单，就把一级菜单放上。
          if (recData.secondMenu.length == 0) {
            this.menuList = [
              {
                label: recData.firstMenuName,
                id: recData.menuId
              }
            ];
          } else {
            //多条列表
            this.menuList = recData.secondMenu;
            if (
              choosedItem.label == "仪器预约记录" ||
              choosedItem.label == "实验室预约记录" ||
              choosedItem.label == "使用记录" ||
              choosedItem.label == "考勤记录" ||
              choosedItem.label == "成绩查询" ||
              recData.menuName == "实验室信息" ||
              recData.menuName == "违规扣分处罚信息"
            ) {
              this.$router.push({
                path: "detail:contentId",
                name: "Detail",
                params: {
                  contentId: this.contentList[0].id,
                  label: choosedItem.label
                }
              });
            }
          }
          this.fullscreenLoading = false;
        })
        .catch(error => {
          this.fullscreenLoading = false;
        });


    },
    toDetail(row,index) {
      this.activeIndex = index;
      document.titel=row.title
      this.$router.push({
        path: "detail:contentId",
        name: "Detail",
        params: { contentId: row.id, label: row.title }
      });
    }
  },
  watch:{
    $route(newVal,oldVal){
      if(newVal.params.menuId){
        this.menuId = newVal.params.menuId;
        this.getSecondList();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.params.menuId) {
        this.menuId = this.$route.params.menuId;
        this.getSecondList();
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    // if (this.$route.params.menuId) {
    this.menuId = this.$route.params.menuId;
    this.getSecondList();
    next();
    // }
  },
};
</script>


<style scoped lang="less">
.content{
  width: 100%;
  padding: 10px;
  min-height: 100vh;
  position: relative;
  .bgTitle{
    background: url("~@/assets/list/mobileTitle_bg.jpg") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 60px;
    padding: 3px 10px 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p{
      font-size: 24px;
      color: #fff;
    }
  }
  .content-list{
    margin-top: 10px;
    height: 800px;
    overflow-y: auto;
    //height: ;
      .card_data{
        width: 100%;
        height: 100px;
        margin-bottom: 10px;
        .card_flex{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left_box{
            width: 80%;
            .titleTime{
              color: #a1a1a1;
              font-size: 12px;
            }
          }
          .right_box{
            width: 22%;
            height: 100%;
            img{
              width: 100%;
              height: 60px;
              object-fit: cover;
            }
          }
        }
      }
      .active_card{
        width: 100%;
        height: 100px;
        margin-bottom: 10px;
        //左边框
        border-left: #002b9e 3px solid;
        .card_flex{
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left_box{
            width: 80%;
            .titleTime{
              color: #a1a1a1;
              font-size: 12px;
            }
          }
          .right_box{
            width: 22%;
            height: 100%;
            img{
              width: 100%;
              height: 60px;
              object-fit: cover;
            }
          }
        }
        .title{
          color: #002b9e;
        }
      }

  }
  .dropdown {
    position: relative;
    display: inline-block;
    width: 100%;
    z-index: 99999;
  }

  .dropdown-header {
    //padding: 10px;
    cursor: pointer;
    user-select: none; /* 防止文本被选择 */
    background: url("~@/assets/list/mobileTitle_bg.jpg") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 60px;
    padding: 0 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p{
      font-size: 18px;
      color: #fff;
      font-weight: bold;
    }
  }

  .dropdown-content {
    max-height: 0;
    overflow: auto;
    position: absolute;
    background-color: #fff;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
    width: 100%; /* 确保宽度和头部一致 */
    transition: max-height 0.5s ease-out; /* 动画效果 */
  }
  .active_dropdown-item{
    padding: 10px;
    cursor: pointer;
    height: 50px;
    font-size: 18px;
    font-weight: bold;
    color: #002b9e;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .dropdown-item {
    padding: 10px;
    cursor: pointer;
    height: 50px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .dropdown.open .dropdown-content {
    max-height: 600px; /* 多级菜单需要更大高度 */
    background-color: #f2f2f2;
  }
  /deep/.el-pagination__jump{
    margin-left: 6px;
  }
}
</style>
